import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/trAuth';

const SuperAdminRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== 'superadmin') {
    return <Navigate to="/admin/tracking" replace />;
  }

  return children;
};

export default SuperAdminRoute;
